
import React, { useState, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "@ag-grid-community/react";
import { Dialog } from "primereact/dialog";
import { useGuestlist } from "../../../Hooks/Features/Gatepass/useGuestList.js";
import { Dropdown } from "primereact/dropdown";
import { SkeletonDataTable } from "../../Loader/Loader.jsx";
import { dateConvert } from "../../../utils/Helper.js";
import DatePicker from 'react-multi-date-picker';
import { useCommon } from "../../../Hooks/Common/useCommon.js";
import _ from "underscore";
import CommanDialog from "../../CommonCompo/CommanDialog/CommanDialog.js";
import CommonFilterDropdown from "../../CommonCompo/CommonFilterDropdown/CommonFilterDropdown.jsx";


export const GuestList = () => {
  const { checkPermission } = useCommon();
  const { filterValues, setfilterValues, handleRequest, columnDefs, rowData, handleAccess, sethandleAccess, getVisitorList, popupVisible, setPopupVisible, loader, inputList, handleInputChange, handleAddClick, handleVehicleAddClick, vehicleinputList, handleVehicleInputChange, inputs, setinputs, handleSubmit, dropdownOpt, hoveredRange, setHoveredRange, tagRef, handleEvents, printData, contentRef, handleReset, showPopUp, setShowPopup, selectedData } = useGuestlist();
  const [showFiltersDrawer, setShowFiltersDrawer] = useState(false);
  const datePickerRef = useRef(null);

  const handleKeyPress = (e) => {
    const charCode = e.charCode || e.keyCode;
    if (charCode < 48 || charCode > 57) {
      e.preventDefault(); // Prevent the input of anything that is not a digit
    }
  };

  return (
    <div ref={() => checkPermission("GuestList", tagRef)}>
      <div ref={tagRef} id='{"tabname": "GuestList", "data": "guestlist_tab"}' >
        <div className="d-flex justify-content-between align-items-center my-2 gap-3 px-3">
          <div className="d-flex gap-2 align-items-center flex-grow-1">
            <h5 className="mb-0 text-nowrap">Guest List</h5>
          </div>
          <div className="d-flex justify-content-end align-items-center gap-2">
            <button className="sk-btn-primary rounded" onClick={() => getVisitorList()} title="Refresh"><FontAwesomeIcon icon="fa-solid fa-arrows-rotate" /></button>
            <button className="sk-btn-primary rounded" onClick={() => setShowFiltersDrawer(true)} title="Filters"><FontAwesomeIcon icon="fa-solid fa-filter" /></button>
            <button className="button btn-primary rounded" onClick={() => {
              setPopupVisible(true);
              setinputs((prevState) => ({
                ...prevState,
                role_on_project: '',
                visitorName: "",
                usercode: "",
                status: 'pending',
                time: "",
                remark: "",
                currentTime: dateConvert(new Date(), 'date-time-months'),
                search: '',
                textAreaVisible: false,
                selectedMeet: null,
                selectedDocument: null,
                selectedReason: null,
                selectedVehicleType: null,
                selectedComp: null,
                selectedDocumentNumber: ''
              }))
              sethandleAccess((prevState) => ({ ...prevState, current_visit_id: 0 }))
            }}><FontAwesomeIcon icon="fa-solid fa-plus" title="Add Request" /> Request</button>
          </div>
        </div>
        {loader ? <div><SkeletonDataTable numSkeletons={15} /></div> :
          <div
            className="ag-theme-alpine"
            style={{ height: "calc(100vh - 120px)" }}
          >
            <AgGridReact
              rowData={rowData}
              columnDefs={columnDefs}
              rowHeight={30}
              headerHeight={30}
            />
          </div>
        }
        {
          !_.isEmpty(printData) && <div ref={contentRef} className="printContent p-2">
            <div className="w100 my-5 p-2 rounded " style={{ border: "2px solid gray" }}>
              <header className="d-flex justify-content-between align-items-center text-capitalize mb-3">
                <img
                  src="./assets/srkay-logo-light.png"
                  alt="SRKay Consulting Group Logo"
                  width={110}
                  height={30}
                />
                <span className="fw-bold">Visitor No: {printData?.visitor_number}</span>
              </header>
              <section>
                {printData.map(({ label, value }) => (
                  <div className="mb-2 d-flex" key={label}>
                    <span className="fw-semibold d-inline-block me-2" style={{ minWidth: 100 }}>{label}</span>
                    <span className="text-capitalize">: {value || "-"}</span>
                  </div>
                ))}
              </section>
              <footer className="d-flex justify-content-between align-items-center mt-3 ">
                <small className="text-capitalize">One time use only</small>
                <span className="fw-semibold">Authorised Signature</span>
              </footer>
            </div>
          </div>
        }
        <Dialog className="modal-xxl"
          onHide={() => {
            handleReset()
            setPopupVisible(false);
          }}
          visible={popupVisible} header="Create Request" draggable={false} >
          <div style={{
           
            padding: '20px',
            borderRadius: '8px', 
            // overflow: 'hidden',
            // maxHeight: '100vh',
          }}>
            <Dropdown showClear style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px' }} placeholder="Whom To Meet" filter filterInputAutoFocus optionLabel="user_display_name" options={dropdownOpt.meet} value={inputs.selectedMeet} onChange={(e) => setinputs((prevState) => ({ ...prevState, selectedMeet: e.target.value }))} />

            <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '15px' }}>
              <img src="./assets/logo.png" alt="srkay-logo" style={{ width: '50px', height: '50px', borderRadius: '50%' }} />
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div className="row">
                  <div className="col-8" style={{ width: '115%' }}>
                    {inputs.selectedMeet !== null ? <h3 style={{ margin: '0', fontSize: '16px' }}>{inputs?.selectedMeet?.user_display_name}</h3> : ""}
                    <h3 style={{ margin: '0', fontSize: '16px' }}>{inputs?.selectedMeet?.employee_id}</h3>
                  </div>
                  <div className="col-2 " style={{ width: '115%' }} >
                    {inputs?.selectedMeet !== null && <span className="parentlink" >{inputs?.selectedMeet?.role_on_project}</span>}
                    <p style={{ margin: '0' }}>1st Floor (2nd Row - 5th Seat)</p>
                  </div>
                </div>
              </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              <h4>Visitor Info.</h4>
              <div style={{ display: 'flex', gap: '50%' }}>
                <label style={{ width: "36%" }}>In Time: <strong>{inputs.currentTime}</strong></label>
              </div>
              <div >
                {inputList.map((x, i) => (
                  <div key={i} style={{  gap: '10px' }}>
                    <input
                      type="text"
                      name="phonenumber"
                      className="input-dd"
                      value={x.phonenumber}
                      onKeyPress={(e) => handleKeyPress(e)} // Listen for key press events
                      onChange={e => handleInputChange(e, i)}
                      placeholder="Mobile Number"
                      maxLength="10"
                      pattern="\d*" // This allows only numeric characters

                      
                    />
                    <input
                      type="text"
                      name="firstname"
                      value={x.firstname}
                      onChange={e => handleInputChange(e, i)}
                      placeholder="First Name"
                      className="input-dd"
                      
                      onKeyPress={e => {
                        if (/[0-9]/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                    <input
                      type="text"
                      name="lastname"
                      value={x.lastname}
                      onKeyPress={e => {
                        if (/[0-9]/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      onChange={e => handleInputChange(e, i)}
                      placeholder="Last Name"
                      className="input-dd"
                      
                    />
                    {/* <label style={{ width: "29%" }}>Out Time:
                      <input type="time" id="out-time" defaultValue={x.outtime} name="time" style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px' }} onChange={e => handleInputChange(e, i)} className="input-dd" />
                    </label> */}
                    <Dropdown value={x.selectedDocument} name="selectedDocument" showClear
                      placeholder="Document" options={dropdownOpt.document} optionLabel="document_type_name" filter filterInputAutoFocus
                      className="input-dd" onChange={e => handleInputChange(e, i)} />
                    <input
                      type="text"
                      name="selectedDocumentNumber"
                      className="input-dd"
                      value={x.selectedDocumentNumber}
                      onChange={e => handleInputChange(e, i)}
                      placeholder="Document  Number"
                      
                    />
                  </div>
                ))}
              </div>
              {<span> <button style={{ background: 'none', border: 'none', color: 'blue', cursor: 'pointer', fontSize: '14px' }} onClick={handleAddClick}>Add More</button></span>}
              <Dropdown placeholder="Reason For Visit" options={dropdownOpt.visitorreason} showClear onChange={(e) => {
                setinputs((prevState) => ({ ...prevState, selectedReason: e.target.value }))
                if (e.value.reasons === 'Other') {
                  setinputs((prevState) => ({ ...prevState, textAreaVisible: true }))
                } else {
                  setinputs((prevState) => ({ ...prevState, textAreaVisible: false }))

                }
              }} optionLabel="reasons" value={inputs.selectedReason} />

              {inputs.textAreaVisible && <textarea defaultValue={inputs.remark} onChange={(e) => setinputs((prevState) => ({ ...prevState, remark: e.target.value }))} placeholder="Reason For Visit" style={{ width: '100%', height: '50px', padding: '8px', border: '1px solid #ccc', borderRadius: '4px' }}></textarea>}
              <h4>Vehicle Info.</h4>
              {vehicleinputList.map((x, i) => (
                <div className="d-flex gap-2  align-items-end">
                  <div className="col-2">
                    <Dropdown style={{ width: '100%' }} placeholder="Vehicle Type" name='selectedVehicleType' options={dropdownOpt.vehicle}
                      onChange={(e) => handleVehicleInputChange(e, i)} optionLabel="vehical_type_name" className="input-dd" value={x.selectedVehicleType} showClear />
                  </div>
                  <div className="col-3">
                    <Dropdown style={{ width: '100%' }} showClear placeholder="Vehicle Company" name='selectedComp' options={dropdownOpt.vehicleComp} onChange={(e) => handleVehicleInputChange(e, i)} optionLabel="vehical_company_name" className="input-dd" value={x.selectedComp} />
                  </div>
                  <div className="col-7">
                    <h6>Vehicle Number:</h6>
                    <div key={i} style={{ display: 'flex', gap: '10px' }}>
                      <input
                        type="text"
                        placeholder="GJ"
                        maxLength="2"
                        style={{ width: '50px', padding: '8px', textAlign: 'center' }}
                        name="field_one"
                        value={x.field_one}
                        onChange={(e) => handleVehicleInputChange(e, i)}
                        className="input-dd"
                      />
                      <input
                        type="text"
                        placeholder="05"
                        maxLength="2"
                        onKeyPress={(e) => handleKeyPress(e)}
                        style={{ width: '50px', padding: '8px', textAlign: 'center' }}
                        name="field_two"
                        value={x.field_two}
                        onChange={(e) => handleVehicleInputChange(e, i)}
                        className="input-dd"
                      />
                      <input
                        type="text"
                        placeholder="RR"
                        maxLength="2"
                        style={{ width: '60px', padding: '8px', textAlign: 'center' }}
                        name="field_three"
                        value={x.field_three}
                        onChange={(e) => handleVehicleInputChange(e, i)}
                        className="input-dd"
                      />
                      <input
                        type="text"
                        placeholder="7787"
                        maxLength="4"
                        onKeyPress={(e) => handleKeyPress(e)}
                        style={{ width: '50px', padding: '8px', textAlign: 'center' }}
                        name="field_four"
                        value={x.field_four}
                        onChange={(e) => handleVehicleInputChange(e, i)}
                        className="input-dd"
                      />
                    </div>
                  </div>
                </div>
              ))}
              <div>
              </div>
              {<span> <button style={{ background: 'none', border: 'none', color: 'blue', cursor: 'pointer', fontSize: '14px' }} onClick={handleVehicleAddClick}>Add More</button>
              </span>}
              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
                <button style={{ background: '#ccc', border: 'none', padding: '8px 12px', cursor: 'pointer' }}
                  onClick={handleReset}>Cancel</button>
                <button style={{ background: 'green', color: 'white', border: 'none', padding: '8px 12px', cursor: 'pointer' }} onClick={handleSubmit}>Submit</button>
              </div>
            </div>
          </div>
        </Dialog>

        <Dialog
          visible={handleAccess.showPopUp}
          header="Visitor Access Request"
          onHide={() => {
            sethandleAccess(false);
            sethandleAccess((prevState) => ({ ...prevState, showPopUp: false, radio: "" }))
          }}
          className="modal-medium"
          draggable={false}
        >
          <div className="dialog-content" style={{ textAlign: 'center' }}>
            <>
              <p style={{ fontSize: '16px', marginBottom: '20px', color: '#555' }}>
                Please select your decision:
              </p>

              <div>
                <label>
                  <input
                    type="radio"
                    value="approve"
                    checked={handleAccess.radio === 'approve'}
                    onChange={(e) => sethandleAccess((prevState) => ({ ...prevState, radio: e.target.value }))
                    }
                    style={{ marginRight: '10px' }}
                  />
                  Approve
                </label>
                <label>
                  <input
                    type="radio"
                    value="denied"
                    checked={handleAccess.radio === 'denied'}
                    onChange={(e) => sethandleAccess((prevState) => ({ ...prevState, radio: e.target.value }))
                    }
                    style={{ marginLeft: '20px', marginRight: '10px' }}
                  />
                  Reject
                </label>
              </div>


              <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', marginBottom: '20px' }}>
                <button className="button btn-primary"
                  onClick={() => handleRequest(null, null)}
                > Confirm </button>
                <button
                  onClick={() => {
                    sethandleAccess((prevState) => ({ ...prevState, showPopUp: false, radio: "" }))
                  }}
                  className="button btn-default"              >
                  Cancel
                </button>
              </div>
            </>
          </div>
        </Dialog>
        <CommanDialog
          visible={showPopUp}
          message={"Are you sure the selected person has left?"}
          handleClose={() => { setShowPopup(false) }}
          handleFun={() => {
            handleRequest(selectedData, true)
          }}
        />
      </div>

      {/* Right Panel Filters Drawer */}
      <div className={`sk-drawer-overlay ${showFiltersDrawer ? 'active' : ''}`} onClick={(e) => { if (e.target === e.currentTarget) setShowFiltersDrawer(false); }}>
        <div className={`sk-drawer-panel ${showFiltersDrawer ? 'open' : ''}`}>
          <div className="sk-drawer-header">
            <h5 className="sk-drawer-title">Filters</h5>
            <div className="d-flex align-items-center gap-2">
              <button className="sk-drawer-clear-btn" onClick={() => {
                setfilterValues({
                  ...filterValues,
                  visitor_name: [],
                  users: [],
                  isChange: true
                });
                setHoveredRange(null);
                setinputs((prev) => ({ ...prev, status: 'pending' }));
              }}>Clear All</button>
              <button className="sk-drawer-close-btn" onClick={() => setShowFiltersDrawer(false)}>
                <FontAwesomeIcon icon="fa-solid fa-xmark" />
              </button>
            </div>
          </div>
          <div className="sk-drawer-body">
            <div className='d-flex flex-column gap-4'>
              {/* Status Filter */}
              <div className="sk-drawer-filter-group">
                <div className="task-list-filter-label">Status</div>
                <div className="sk-segment-control mb-3">
                  <button type="button" className={`sk-segment-btn ${inputs.status === 'pending' ? 'active' : ''}`} onClick={() => {
                    setinputs((prev) => ({ ...prev, status: 'pending' }));
                    getVisitorList({}, 'pending');
                  }}>Pending</button>
                  <button type="button" className={`sk-segment-btn ${inputs.status === 'approve' ? 'active' : ''}`} onClick={() => {
                    setinputs((prev) => ({ ...prev, status: 'approve' }));
                    getVisitorList({}, 'approve');
                  }}>Approved</button>
                  <button type="button" className={`sk-segment-btn ${inputs.status === 'denied' ? 'active' : ''}`} onClick={() => {
                    setinputs((prev) => ({ ...prev, status: 'denied' }));
                    getVisitorList({}, 'denied');
                  }}>Rejected</button>
                </div>
              </div>

              {/* Datepicker Range Filter */}
              <div className="sk-drawer-filter-group">
                <div className="task-list-filter-label">Select Date Range</div>
                <DatePicker
                  ref={datePickerRef}
                  value={hoveredRange}
                  onChange={(e) => {
                                            if (!e || e.length === 2) {
                                                setHoveredRange(e);
                    if (e && e.length === 2) {
                      datePickerRef.current?.closeCalendar();
                    }
                                            }
                                        }}
                  range
                  rangeHover
                  style={{ width: "100%" }}
                  containerStyle={{ width: "100%" }}
                />
              </div>

              {/* Core Filters */}
              <div className="sk-drawer-filter-group">
                <div className="task-list-filter-label">Core Filters</div>
                <CommonFilterDropdown
                  fields={[
                    { key: "visitor_name", label: "Visitor", col: 12 },
                    { key: "users", label: "Meet", col: 12 },
                  ]}
                  filterValues={filterValues}
                  setFilterValues={setfilterValues}
                />
              </div>
            </div>
          </div>
          <div className="sk-drawer-footer">
            <button className="sk-btn .sk-btn-primary-filter w-100 py-2" onClick={() => {
              getVisitorList(hoveredRange, inputs.status);
              setShowFiltersDrawer(false);
            }}>Apply Filters</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GuestList;
